import React, { useState, useEffect } from 'react';
import TR from './../../Trans';
import ListItemButton from '@mui/material/ListItemButton';
import { useInView } from "react-intersection-observer";
import ListItemText from '@mui/material/ListItemText';
import Popover from '@mui/material/Popover';
import FormControlLabel from '@mui/material/FormControlLabel';
import Tooltip from '@mui/material/Tooltip';
import Checkbox from '@mui/material/Checkbox';
import ListItemIcon from '@mui/material/ListItemIcon';
import Button from '@mui/material/Button';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as VocIcon } from './../../assets/voc.svg';
import Avatar from '@mui/material/Avatar';
import AlbumIcon from '@mui/icons-material/Album';
import dayjs from 'dayjs';
import RemoveFavorite from '../dialogs/RemoveFavorite';
import StarIcon from '@mui/icons-material/Star';
import IconButton from '@mui/material/IconButton';
import settingsStore from '../../stores/settings';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { ReactComponent as HotIcon } from './../../assets/hot.svg';
import favoritesStore from '../../stores/favorites';
import sessionStore from '../../stores/session';
import performanceStore from '../../stores/performance';

const TrackListItem = React.memo(function TrackListItem(props) {

  const sessionToken = sessionStore((state) => state.sessionToken);
  const deleteFavorite = favoritesStore((state) => state.deleteFavorite);
  const setFavorite = favoritesStore((state) => state.setFavorite);
  const performanceToBeChanged = performanceStore((state) => state.performanceToBeChanged);
  const settingsUsageMode = settingsStore((state) => state.settings?.usage_mode);
  const isFavorite = favoritesStore(
    (state) => state.tracks?.find(x => x.track_id == props.track.track_id && x.is_favorite == 1)
  );

  const [showPlay, setShowPlay] = useState(false);
  const [anchorFavoriteEl, setAnchorFavoriteEl] = useState(null);
  const openFavoritePopover = Boolean(anchorFavoriteEl);
  const [isRemoveFavoriteOpen, setIsRemoveFavoriteOpen] = useState(false);

  const handleOpenRemoveFavorite = (e) => {
    e.stopPropagation();
    setIsRemoveFavoriteOpen(true);
  };

  const handleCloseRemoveFavorite = (e) => {
    e.stopPropagation();
    setIsRemoveFavoriteOpen(false);
  };

  const handleCloseFavorite = (event) => {
    event.stopPropagation();
    setAnchorFavoriteEl(null);
  };

  const handleClickFavorite = (event) => {
    event.stopPropagation();
    handleSetFavorite(event);
  };

  const handleSetFavorite = (event) => {
    event.stopPropagation();
    if (isFavorite) {
      deleteFavorite(sessionToken, props.track);
    } else {
      setFavorite(sessionToken, props.track);
    }
  };

  const primaryText = () => {
    if (props.isBackgroundMusic) {
      return <div>
        {highlightText(props.track.title)}
      </div>;
    } else {
      return <div>
        {highlightText(props.track.title)} <span>{hotImg()} {vocalImg()}</span>
      </div>;
    }
  };

  const secondaryText = () => {
    return highlightText(props.track.artist);
  };

  const lengthToMinutes = (length) => {
    const splitted = length.split(":");
    if (splitted.length == 3) {
      return splitted[1] + ":" + splitted[2];
    }
  };

  const hotImg = () => {
    if (props.track) {
      if (props.track.is_new == 1) {
        return <Tooltip title={TR.cm_trending_tracks}><SvgIcon className="muvika-icon track-list-item-icon" component={HotIcon} /></Tooltip>;
      }
    }
  };

  const vocalImg = () => {
    if (props.track) {
      if (props.track.flags) {
        if (props.track.flags.includes("voc_avail")) {
          return <Tooltip title={TR.cm_vocal_version_available}><SvgIcon className="muvika-icon track-list-item-icon" component={VocIcon} /></Tooltip>;
        }
      }
    }
  };

  const showPlayIcon = () => {
    if (showPlay) {
      return <PlayArrowIcon className="muvika-track-play-icon" />;
    }
  };

  const highlightText = (text) => {
    if (!props.highlight || !text) return text;

    const escaped = props.highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escaped})`, 'gi');

    return text.split(regex).map((part, i) =>
      part.toLowerCase() === props.highlight.toLowerCase()
        ? <span className="muvika-filter-highlight" key={i}>{part}</span>
        : part
    );
  };

  const infoRightSide = () => {
    if (props.isNewTracks) {
      return (
        <ListItemText
          className="muvika-date-nowrap"
          primary={dayjs(props.track.license_released).format('YYYY-MM-DD')}
          secondary={highlightText(props.track.kcode)}
        />
      );
    } else {
      return (
        <ListItemText
          primary={lengthToMinutes(props.track.length)}
          secondary={highlightText(props.track.kcode)}
        />
      );
    }
  };

  const handleItemClick = (e) => {
    if (props.onAddPerformance) {
      if (performanceToBeChanged) {
        props.onChangeTrackPerformance(e);
      } else {
        props.onAddPerformance(e);
      }
    }
    if (props.onAddBackgroundMusic) {
      props.onAddBackgroundMusic(e);
    }
  };

  const renderStarIcon = () => {
    if (isFavorite) {
      return <StarIcon className="muvika-yellow-star" />;
    } else {
      return <StarIcon className="muvika-empty-star" />;
    }
  };

  const renderFavoritesStar = () => {
    if (!props.isBackgroundMusic && !props.isSongbook) {
      if (settingsUsageMode) {
        if (settingsUsageMode === "restaurant") {
          return <div>
            <IconButton color="white" component="label" size="large" onClick={(e) => {

              if (isFavorite && props.isOnFavoritesView) {
                handleOpenRemoveFavorite(e);
              } else {
                handleSetFavorite(e);
              }
            }}>
              {renderStarIcon()}
            </IconButton>
          </div>;
        }
      } else {
        return <div>
          <IconButton color="white" component="label" size="large" onClick={(e) => {

            if (isFavorite && props.isOnFavoritesView) {
              handleOpenRemoveFavorite(e);
            } else {
              handleSetFavorite(e);
            }
          }}>
            {renderStarIcon()}
          </IconButton>
        </div>;
      }
    }
  };

  const renderAvatar = () => {
    if (props.isBackgroundMusic) {
      return <ListItemAvatar className="muvika-track-avatar-item">
        <ListItemIcon>
          <AlbumIcon />
        </ListItemIcon>
      </ListItemAvatar>;
    } else {
      return <ListItemAvatar className="muvika-track-avatar-item">
        <Avatar className="muvika-track-avatar">
          {showPlayIcon()}
          <img className="muvika-track-avatar-image" src={props.track.url_thumb_image} alt="" />
        </Avatar>
      </ListItemAvatar>;
    }
  };

  const renderButton = () => {
    console.log("render again");
    return <ListItemButton sx={props.sx} onClick={handleItemClick} onMouseOver={() => setShowPlay(true)} onMouseOut={() => setShowPlay(false)}>
      <RemoveFavorite open={isRemoveFavoriteOpen} onClose={handleCloseRemoveFavorite} onConfirmation={handleClickFavorite} />
      {renderAvatar()}
      <ListItemText primary={primaryText()} secondary={
        <div>
          {secondaryText()}
        </div>
      } />
      <ListItemText className="muvika-track-right">
        {infoRightSide()}
      </ListItemText>
      {renderFavoritesStar()}
    </ListItemButton>;
  };

  return (
    <div>
      {renderButton()}
    </div>
  );
});

export default TrackListItem;